var React = require('react');

function Triangle (props) {
    return React.createElement("svg",props,[React.createElement("desc",{"key":0},"Created with Sketch."),React.createElement("defs",{"key":1}),React.createElement("g",{"id":"icons/triangle/right/dark","transform":"translate(-13.000000, -10.000000)","key":2},React.createElement("polygon",{"id":"Triangle","points":"19.6666667 16 13 10 13 22"}))]);
}

Triangle.defaultProps = {"width":"7px","height":"12px","viewBox":"0 0 7 12","version":"1.1"};

module.exports = Triangle;

Triangle.default = Triangle;
